document.addEventListener("DOMContentLoaded", () => {
  const selector = '[data-section-type="product-table-concile"] form[action="/cart/add"]';
  const forms = document.querySelectorAll(selector);

  // 👉 Passe/ergänze hier, falls dein Header andere Klassen nutzt:
  const CART_COUNT_SELECTORS = [
    '[data-cart-count]',         // bevorzugt: eigenes Data-Attribut
    '.cart-count-badge',         // custom
    '.header-cart-count',        // custom
    '.header__cart-count',       // Dawn-ähnlich
    '.js-cart-count',            // häufig in Themes
    '#CartCount'                 // ältere Themes
  ];

  async function fetchCartJSON() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }});
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  function setCartCountOnPage(count) {
    const nodes = CART_COUNT_SELECTORS
      .map(sel => Array.from(document.querySelectorAll(sel)))
      .flat()
      .filter(Boolean);

    nodes.forEach(node => {
      // Falls Badge nur sichtbar sein soll, wenn > 0:
      if (count > 0) {
        node.style.display = ''; // sicherstellen, dass es sichtbar ist
      } else {
        // optional: ausblenden, wenn 0
        // node.style.display = 'none';
      }

      // Häufig reicht innerText:
      node.innerText = String(count);

      // Falls das Badge die Zahl in einem Attribut hält (z.B. aria-label)
      node.setAttribute?.('data-cart-count', String(count));
      node.setAttribute?.('aria-label', `Warenkorb: ${count} Artikel`);
    });
  }

  async function updateCartCount() {
    try {
      const cart = await fetchCartJSON();
      const count = cart.item_count || 0;
      setCartCountOnPage(count);
      // Optional: globalen Event dispatchen, falls andere Teile darauf lauschen
      document.dispatchEvent(new CustomEvent('cart:count-updated', { detail: { count } }));
    } catch (e) {
      console.warn('Konnte Warenkorbanzahl nicht aktualisieren:', e);
    }
  }

  if (!forms.length) return;

  forms.forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      const button = form.querySelector(".add-btn");
      const formData = new FormData(form);
      if (!button) return;

      const originalText = button.innerHTML;
      button.disabled = true;
      button.innerHTML = "Wird hinzugefügt…";

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
        });
        if (!res.ok) throw new Error("Fehler beim Hinzufügen");
        await res.json();

        // Erfolgsfeedback
        button.innerHTML = "✔ Hinzugefügt";
        button.classList.add("added");

        // 🔁 Direkt danach den Cart laden und Badge aktualisieren
        updateCartCount();

        setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
          button.classList.remove("added");
        }, 2000);
      } catch (err) {
        console.error("Add-to-Cart-Fehler:", err);
        button.innerHTML = "Fehler!";
        setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
        }, 2000);
      }
    });
  });
});